import { render, staticRenderFns } from "./DownloadResult.vue?vue&type=template&id=59b6d472&scoped=true"
import script from "./DownloadResult.vue?vue&type=script&lang=js"
export * from "./DownloadResult.vue?vue&type=script&lang=js"
import style0 from "./DownloadResult.vue?vue&type=style&index=0&id=59b6d472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b6d472",
  null
  
)

export default component.exports